module.exports = __webpack_public_path__ + "img/hero-house.a9ea32f8.png";